import { DivisionDto } from './division.dto';

export class Division {
    readonly id: string;
    readonly code: string;
    readonly name: string;

    constructor(dto: DivisionDto) {
        this.id = dto.id;
        this.code = dto.code;
        this.name = dto.name;
    }
}
